export default "__VITE_ASSET__380232d9__"